import { render, staticRenderFns } from "./Domain.vue?vue&type=template&id=b71795dc&scoped=true&lang=pug&"
import script from "./Domain.vue?vue&type=script&lang=js&"
export * from "./Domain.vue?vue&type=script&lang=js&"
import style0 from "./Domain.vue?vue&type=style&index=0&id=b71795dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71795dc",
  null
  
)

export default component.exports